import { render, staticRenderFns } from "./CoupassStageCards.vue?vue&type=template&id=38bcf643&scoped=true"
import script from "./CoupassStageCards.vue?vue&type=script&lang=js"
export * from "./CoupassStageCards.vue?vue&type=script&lang=js"
import style0 from "./CoupassStageCards.vue?vue&type=style&index=0&id=38bcf643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bcf643",
  null
  
)

export default component.exports